import {Injectable} from '@angular/core';
import {HttpCommonService} from "./http-common.service";
import {Observable} from "rxjs/Observable";

@Injectable()
export class EnterpMonitorService {

  constructor(private http: HttpCommonService) {
  }

  /**
   * 查询企业监测列表
   * @param params
   * @returns {Observable<any>}
   */
  getEnterpMonitorList(params: any): Observable<any> {
    // console.log(params);
    return this.http.post('/enterprise/detail/monitor/findPageMonitors', {
      typeNameFirst: params.riskItem == '-1' ? null : params.riskItem,
      pageNo: params.page.pageNo,
      pageSize: params.page.pageSize,
      dateRange: params.dateRange == '-1' ? null : params.dateRange,
      key:params.key,
      type: params.type,
      companyId: params.companyId
    });
  }

}

export class EnterpMonitor {
  public id: string;
  public companyId: string;
  public companyName: string;
  public date: Date;
  public type: string;
  public content: string;
  public riskItem: string;
  public riskLevel: string;
  public titleDesc: string;

  constructor(item: any) {
    this.id = item.ID;
    this.companyId = item.COMPANY_ID;
    this.companyName = item.COMPANY_NAME;
    this.date = item.CREATE_DATE;
    this.type = item.TYPE_NAME_SECOND;
    this.content = item.MONITOR_CONTENT;
    this.riskItem = item.TYPE_NAME_FIRST;
    this.riskLevel = item.MONITOR_TYPE_ID;
    this.titleDesc = item.COMPANY_NAME + '：' + item.MONITOR_CONTENT;
  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/enterp-monitor.service.ts